import React, { useState, useEffect } from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { URLS } from "../../Url"
import axios from "axios"
import {
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts"

const Dashboard = () => {
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const TokenData = TokenJson.token

  const [TopProducts, setTopProducts] = useState([])

  useEffect(() => {
    getDashboardData()
  }, [])

  const getDashboardData = () => {
    const token = TokenData
    axios
      .post(
        URLS.GetDashboard,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setTopProducts(res?.data?.topProducts || [])
      })
      .catch(error => {
        console.error("Error fetching dashboard data:", error)
      })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="mb-3">
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <h2 className="font-semibold mb-2">Top Selling Products</h2>
                    <ResponsiveContainer width="100%" height={300}>
                      <BarChart layout="vertical" data={TopProducts}>
                        <XAxis type="number" />
                        <YAxis dataKey="name" type="category" />
                        <Tooltip />
                        <Bar dataKey="sales" fill="#0088FE" />
                      </BarChart>
                    </ResponsiveContainer>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
